import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { useLoader } from "../../../utils/common";

const API_URL = "/admin/about-us/brands";

// preview of the picked file
const Preview = ({ file }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (file && file.length) {
      const u = URL.createObjectURL(file[0]);
      setUrl(u);
      return () => URL.revokeObjectURL(u);
    }
    setUrl("");
  }, [file]);
  if (!url) return null;
  return <img src={url} alt="Preview" className="image-preview mt-2" style={{ maxWidth: 160, maxHeight: 130 }} />;
};

const AddBrand = ({ handleClose }) => {
  const { postData } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ defaultValues: { sort_order: 0 } });

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data.name);
      sendData.append("tagline", data.tagline || "");
      sendData.append("sort_order", data.sort_order || 0);
      if (data.image && data.image.length) sendData.append("image", data.image[0]);
      if (data.logo && data.logo.length) sendData.append("logo", data.logo[0]);

      const response = await withLoader(() => postData(API_URL, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Brand Name</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        type="text"
                        placeholder="e.g. Ray-Ban"
                        className={classNames("w-100", { "is-invalid": errors?.name })}
                        {...register("name", { required: "Brand name is required" })}
                      />
                    </InputGroup>
                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Tagline</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="text" placeholder="Optional short line" className="w-100" {...register("tagline")} />
                    </InputGroup>
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Brand Image</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="file" accept="image/*" className="w-100" {...register("image")} />
                    </InputGroup>
                    <small className="text-muted">Optional. Without an image the website shows a card with the brand name.</small>
                  </Form.Group>
                  <Preview file={watch("image")} />
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Logo</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="file" accept="image/*" className="w-100" {...register("logo")} />
                    </InputGroup>
                    <small className="text-muted">Optional. Shown under the image.</small>
                  </Form.Group>
                  <Preview file={watch("logo")} />
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                    <small className="text-muted">Lower numbers show first.</small>
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default AddBrand;